var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83602 11.7695C9.85551 11.7944 9.88041 11.8146 9.90883 11.8284C9.93726 11.8423 9.96846 11.8495 10.0001 11.8495C10.0317 11.8495 10.0629 11.8423 10.0913 11.8284C10.1198 11.8146 10.1447 11.7944 10.1641 11.7695L13.0808 8.07943C13.1876 7.94401 13.0912 7.74349 12.9167 7.74349H10.9871V-1.06901C10.9871 -1.18359 10.8933 -1.27734 10.7787 -1.27734H9.21623C9.10164 -1.27734 9.00789 -1.18359 9.00789 -1.06901V7.74089H7.08342C6.90894 7.74089 6.81258 7.94141 6.91935 8.07682L9.83602 11.7695ZM19.5313 10.8581H17.9688C17.8542 10.8581 17.7605 10.9518 17.7605 11.0664V15.0768H2.23966V11.0664C2.23966 10.9518 2.14591 10.8581 2.03133 10.8581H0.468831C0.354248 10.8581 0.260498 10.9518 0.260498 11.0664V16.2227C0.260498 16.6836 0.632894 17.056 1.09383 17.056H18.9063C19.3673 17.056 19.7397 16.6836 19.7397 16.2227V11.0664C19.7397 10.9518 19.6459 10.8581 19.5313 10.8581Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.3ef77bb50980e27a0268f5574bef1f08.svg";
export { ForwardRef as ReactComponent };